import { render, staticRenderFns } from "./BrowseGoalsPage.vue?vue&type=template&id=cc813ff6&scoped=true"
import script from "./BrowseGoalsPage.vue?vue&type=script&lang=js"
export * from "./BrowseGoalsPage.vue?vue&type=script&lang=js"
import style0 from "./BrowseGoalsPage.vue?vue&type=style&index=0&id=cc813ff6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc813ff6",
  null
  
)

export default component.exports